import { Injectable } from '@angular/core';

// Mirrors the WebCrypto DPoP key generation used by the 2.0 portal (gd-portal-ui)
// so the /login request is accepted the same way there.
@Injectable({
  providedIn: 'root',
})
export class DpopService {
  private keyPair: CryptoKeyPair | null = null;
  private exportedPublicKey: string | null = null;

  async initDpopKey(): Promise<void> {
    if (this.keyPair) {
      return;
    }
    this.keyPair = await window.crypto.subtle.generateKey(
      {
        name: 'RSA-PSS',
        modulusLength: 2048,
        publicExponent: new Uint8Array([1, 0, 1]),
        hash: 'SHA-256',
      },
      false,
      ['sign', 'verify']
    );

    const exported = await window.crypto.subtle.exportKey('spki', this.keyPair.publicKey);
    this.exportedPublicKey = btoa(String.fromCharCode(...new Uint8Array(exported)));
  }

  getDpopPublicKey(): string | null {
    return this.exportedPublicKey;
  }
}
